import Api from '@common/services/api';

export const removeConversation = async (orgId: string, conversationId: string) => {
  return Api.delete(`/v3/organisations/${orgId}/conversations/${conversationId}`);
};
